import { createApiClientContext } from '@wix/package-picker-shared';
const revShareApiClientContext = {};
export const RevShareApiClientContext = createApiClientContext(revShareApiClientContext);
//# sourceMappingURL=rev-share.context.js.map